import { render, staticRenderFns } from "./ConfirmTransferRequests.vue?vue&type=template&id=51fddb61&scoped=true&"
import script from "./ConfirmTransferRequests.vue?vue&type=script&lang=js&"
export * from "./ConfirmTransferRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fddb61",
  null
  
)

export default component.exports